import { render, staticRenderFns } from "./DataStorage.vue?vue&type=template&id=1e300b6a&scoped=true&"
import script from "./DataStorage.vue?vue&type=script&lang=js&"
export * from "./DataStorage.vue?vue&type=script&lang=js&"
import style0 from "./DataStorage.vue?vue&type=style&index=0&id=1e300b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e300b6a",
  null
  
)

export default component.exports